// extracted by mini-css-extract-plugin
module.exports = {"exchangePopConfirm":"SubmitBtn_exchangePopConfirm__3e79Z","exchangeTypeMessage":"SubmitBtn_exchangeTypeMessage__2bBNg","typeText":"SubmitBtn_typeText__2u1oF"};